<template>
  <ul class="flex flex-col gap-16 lg:gap-12">
    <ArticleListRow v-for="article in articles" :article="article" />
  </ul>
</template>

<script lang="ts" setup>
import type { BlogPost } from '~/types/blog-post';
defineProps<{
  articles: BlogPost[];
}>();
</script>
